/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React from "react";

import { ArchiveResult, Assignment } from "../../utils/Interfaces";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { useWindowDimensions } from "../../utils/Hooks";

export interface ArchiveCardProps {
    archiveResult: ArchiveResult;
}

export const ArchiveCard = (props: ArchiveCardProps) => {
    const { archiveResult } = props;

    const { width } = useWindowDimensions();

    const navigate = useNavigate();

    let leftXs: number = width > 1800 ? 11 : width > 1300 ? 10 : width > 900 ? 9 : 8;
    let rightXs: number = width > 1800 ? 1 : width > 1300 ? 2 : width > 900 ? 3 : 4;

    return (
        <Card>
            <CardActionArea onClick={() => navigate(`/work-orders/${archiveResult.id}`)}>
                <CardContent>
                    <Grid container direction="row" xs={12}>
                        <Grid item xs={leftXs}>
                            <Typography variant="h6" fontWeight="bold">
                                {archiveResult.ticket_no}
                            </Typography>
                            <Box sx={{ mb: 2 }} />

                            <Typography sx={{ pr: 3 }}>{archiveResult.problem_description}</Typography>
                            <Box sx={{ mb: 2 }} />

                            <Typography sx={{ pr: 3 }}>{archiveResult.additional_description}</Typography>
                        </Grid>

                        <Grid item xs={rightXs}>
                            <Typography fontWeight="bold">
                                {archiveResult.assignments.length !== 1 ? "Assignees" : "Assignee"}
                            </Typography>
                            <Box sx={{ mb: 2 }} />
                            {archiveResult.assignments.map((assignment: Assignment) => {
                                return (
                                    <Typography key={assignment.technician.username}>
                                        {`${assignment.technician.first_name} ${assignment.technician.last_name}`}
                                    </Typography>
                                );
                            })}
                        </Grid>
                    </Grid>

                    <Box sx={{ mb: 3 }} />

                    <Grid container direction="row" xs={12}>
                        <Grid item xs={leftXs} />
                        <Grid
                            item
                            xs={rightXs}
                            sx={{
                                minWidth: "10%",
                            }}
                        >
                            <Typography fontWeight={"bold"}>Date Completed</Typography>
                            <Typography>{archiveResult.date_completed}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
